import type { BlockDefinition, BlockSerialized, BlockSerializedChild, BlockSerializedSlotOutlet } from '#layers/block-engine/types/block';
import { provide } from 'vue';

export function isBlockSerializedChild(child: any): child is BlockSerializedChild {
	return child && 'blockId' in child;
}

export function isBlockSerializedSlotOutlet(child: any): child is BlockSerializedSlotOutlet {
	return child && 'slotName' in child;
}

export function isBlockDefinition(block: any): block is BlockDefinition {
	return !!block && 'comp' in block;
}

export function isBlockSerialized(block: any): block is BlockSerialized {
	return !!block && 'children' in block;
}

export function provideInBlockEditor(value: boolean) {
	provide('__dsInBlockEditor', value);
}
